import React, { useState } from "react";
import card from "../../../assets/Image/card1.webp";
import { FaAngleLeft } from "react-icons/fa";
import { LuChevronsUpDown } from "react-icons/lu";
import { IoIosAddCircle } from "react-icons/io";

const ItemCard = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="w-40 pt-2 flex flex-col justify-start items-center bg-slate-200 border border-slate-300">
      <img src={card} alt="" />
      <button
        className="mt-2 bg-white flex justify-between items-center  text-sm shadow-sm shadow-black text-black font-bold py-2 px-4 rounded"
        onClick={() => setShowModal(true)}
      >
        <p>
          $2,234.00
          <span className="block font-light text-sm">Card Market</span>
        </p>
        <LuChevronsUpDown className="w-6 h-auto" />
      </button>
      <div className="flex justify-between items-center gap-x-2">
        <button
          className="mt-2 bg-white flex justify-between items-center  text-sm shadow-sm shadow-black text-black font-bold py-2 px-4 rounded"
          onClick={() => setShowModal(true)}
        >
          -
        </button>
        <button
          className="mt-2 bg-white flex justify-between items-center  text-sm shadow-sm shadow-black text-black font-bold py-2 px-4 rounded"
          onClick={() => setShowModal(true)}
        >
          0
          <LuChevronsUpDown className="w-3 h-auto" />
        </button>
        <button
          className="mt-2 bg-white flex justify-between items-center  text-sm shadow-sm shadow-black text-black font-bold py-2 px-4 rounded"
          onClick={() => setShowModal(true)}
        >
          +
        </button>
      </div>
      <button
        className="mt-2 bg-white flex justify-between items-center  text-sm shadow-sm shadow-black text-black font-bold py-2 px-4 rounded"
        onClick={() => setShowModal(true)}
      >
        <p>
          Add Graded
        </p>
        <IoIosAddCircle className="w-8 h-auto" />
      </button>

      <div className="bg-white w-full mt-2">
        <p className="flex">28/30 <IoIosAddCircle className="w-4 h-auto" /></p>
        <p className="font-extrabold">Espeon star</p>
      </div>

      {showModal && (
        <div
          className="fixed z-10 inset-0 overflow-y-auto"
          aria-labelledby="modal-title"
          role="dialog"
          aria-modal="true"
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
              aria-hidden="true"
            ></div>
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              ​
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
              <div className="flex justify-between items-center">
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-transparent font-medium text-black text-5xl  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                  onClick={() => setShowModal(false)}
                >
                  <FaAngleLeft className="w-8 h-auto" />
                </button>

                <p className="font-semibold self-center">Umbreon VMAX</p>
                <div></div>
              </div>

              <div className="flex justify-around items-center">
                <p className="font-extrabold">Condition Source</p>
                <p className="font-extrabold">Price</p>
                <p className="font-extrabold">Details</p>
              </div>
              <hr />
              <div className="flex justify-around items-center">
                <p className="font-extrabold">Condition Source</p>
                <p className="font-extrabold">Price</p>
                <p className="font-extrabold">Details</p>
              </div>
              <hr />
              <div className="flex justify-around items-center">
                <p className="font-extrabold">Condition Source</p>
                <p className="font-extrabold">Price</p>
                <p className="font-extrabold">Details</p>
              </div>
              <hr />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ItemCard;
